import React, { useState } from "react";
import "./../styles/Card.scss";
import Kurumsalpp from "../img/kurumsalpp.png";
import closesvg from "../img/closesvg.svg";
import Api from "../common/api";

const Card = (props) => {
  const [isActive, isSetActive] = useState([]);
  const [BodDatas, setData] = useState([]);
  const lang = localStorage.getItem("lang");
  const subWord = (string, wordCount = 31) => {
    return string ? string.split(" ").slice(0, wordCount).join(" ") : "";
  };

  React.useEffect(() => {
     Api.get("/bods/list/" + props.page).then((res) => {
      setData(res.data.items);
    });
  }, []);

  return BodDatas.length > 0
    ? BodDatas.map((data) => (

      lang == "en" ? (
        <>
          <div className="card">
            <div className="photo">
              <img
                src={"https://sankoenerji.com.tr/" + data.Image}
                alt="pp"
              />
            </div>
            <div className="card-right">
              <h4>{data.Name_EN}</h4>
              <h4>{data.Title_EN}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: subWord(data.Spot_EN),
                  //__html: subWord(data.Add_content),
                }}
              ></div>
            </div>
            <button onClick={() => isSetActive(data.id)}>
              Continue
            </button>
          </div>
          <div
            className={
              isActive == data.id ? "full-modal-box active" : "full-modal-box"
            }
          >
            <div className="modal-box-container">
              <div className="modal-box-container-photo">
                <img
                  src={"https://sankoenerji.com.tr/" + data.Image}
                  alt="asd"
                />
              </div>
              <div className="modal-box-container-content">
                <h4>{data.Name}</h4>
                <h4>{data.Title_EN}</h4>
                <div
                  className="height-auto"
                  dangerouslySetInnerHTML={{
                    __html: data.Content_EN,
                  }}
                ></div>
              </div>
              <button onClick={() => isSetActive([])} className="close-svg-btn">
                <img src={closesvg} alt="close" />
              </button>
            </div>
          </div>
        </> 
        ):(
          <>
            <div className="card">
              <div className="photo">
                <img
                  src={"https://sankoenerji.com.tr/" + data.Image}
                  alt="pp"
                />
              </div>
              <div className="card-right">
                <h4>{data.Name}</h4>
                <h4>{data.Title}</h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html: subWord(data.Spot),
                    //__html: subWord(data.Add_content),
                  }}
                ></div>
              </div>
              <button onClick={() => isSetActive(data.id)}>
                Devamı
              </button>
            </div>
            <div
              className={
                isActive == data.id ? "full-modal-box active" : "full-modal-box"
              }
            >
              <div className="modal-box-container">
                <div className="modal-box-container-photo">
                  <img
                    src={"https://sankoenerji.com.tr/" + data.Image}
                    alt="asd"
                  />
                </div>
                <div className="modal-box-container-content">
                  <h4>{data.Name}</h4>
                  <h4>{data.Title}</h4>
                  <div
                    className="height-auto"
                    dangerouslySetInnerHTML={{
                      __html: data.Add_content,
                    }}
                  ></div>
                </div>
                <button onClick={() => isSetActive([])} className="close-svg-btn">
                  <img src={closesvg} alt="close" />
                </button>
              </div>
            </div>
          </> 
          )
      ))
    : null;
};

export default Card;
